import React from "react";

function QrIcon({ size = "20", fill = "#4072C8" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4459_7073)">
        <path
          d="M9.68571 2.86133V3.69466M14.6857 12.8613H16.3524M11.3524 12.8613H9.68571V16.1947M9.68571 7.02799V9.52799M9.68571 9.52799H9.69404M9.68571 9.52799H13.0274M13.019 16.1947H16.3524M3.01904 9.52799H6.35238M16.3524 9.52799H16.3607M3.85238 6.19466H5.51904C5.74006 6.19466 5.95202 6.10686 6.1083 5.95058C6.26458 5.7943 6.35238 5.58234 6.35238 5.36133V3.69466C6.35238 3.47365 6.26458 3.26169 6.1083 3.10541C5.95202 2.94913 5.74006 2.86133 5.51904 2.86133H3.85238C3.63136 2.86133 3.4194 2.94913 3.26312 3.10541C3.10684 3.26169 3.01904 3.47365 3.01904 3.69466V5.36133C3.01904 5.58234 3.10684 5.7943 3.26312 5.95058C3.4194 6.10686 3.63136 6.19466 3.85238 6.19466ZM13.8524 6.19466H15.519C15.7401 6.19466 15.952 6.10686 16.1083 5.95058C16.2646 5.7943 16.3524 5.58234 16.3524 5.36133V3.69466C16.3524 3.47365 16.2646 3.26169 16.1083 3.10541C15.952 2.94913 15.7401 2.86133 15.519 2.86133H13.8524C13.6314 2.86133 13.4194 2.94913 13.2631 3.10541C13.1068 3.26169 13.019 3.47365 13.019 3.69466V5.36133C13.019 5.58234 13.1068 5.7943 13.2631 5.95058C13.4194 6.10686 13.6314 6.19466 13.8524 6.19466ZM3.85238 16.1947H5.51904C5.74006 16.1947 5.95202 16.1069 6.1083 15.9506C6.26458 15.7943 6.35238 15.5823 6.35238 15.3613V13.6947C6.35238 13.4736 6.26458 13.2617 6.1083 13.1054C5.95202 12.9491 5.74006 12.8613 5.51904 12.8613H3.85238C3.63136 12.8613 3.4194 12.9491 3.26312 13.1054C3.10684 13.2617 3.01904 13.4736 3.01904 13.6947V15.3613C3.01904 15.5823 3.10684 15.7943 3.26312 15.9506C3.4194 16.1069 3.63136 16.1947 3.85238 16.1947Z"
          stroke={fill}
          strokeWidth="1.33818"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4459_7073">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default QrIcon;
